import { pickBy } from '@exodus/basic-utils';
import type { SelectorDefinition } from '@exodus/redux-dependency-injection';

const resultFunction = (assets, availableAssets) =>
  pickBy(
    assets,
    (asset) =>
      !Object.keys(availableAssets).includes(asset.name) && asset.isBuiltIn,
  );

const notAvailableBuiltInDefinition = {
  id: 'notAvailableBuiltIn',
  resultFunction,
  dependencies: [
    //
    { module: 'assets', selector: 'all' },
    { module: 'availableAssets', selector: 'all' },
  ],
} as const satisfies SelectorDefinition;

export default notAvailableBuiltInDefinition;
